/**
 * Page Header Component
 *
 * Korat Health Style: Title with icon + badges + filters
 */

import React from 'react'
import { MapPin } from 'lucide-react'

interface PageHeaderProps {
  icon: React.ElementType
  title: string
  showFilters?: boolean
  filters?: React.ReactNode
  selectedDistrict?: string | null
  selectedSubdistrict?: string | null
}

function Badge({ children }: { children: React.ReactNode }) {
  return (
    <span className="inline-flex items-center gap-1.5 px-2 py-1 rounded-md bg-slate-100 text-xs text-slate-600">
      <MapPin className="w-3 h-3" aria-hidden />
      {children}
    </span>
  )
}

export function PageHeader({
  icon: Icon,
  title,
  showFilters = true,
  filters,
  selectedDistrict,
  selectedSubdistrict,
}: PageHeaderProps) {
  const districtLabel = selectedDistrict || 'ทุกอำเภอ'
  const subdistrictLabel = selectedSubdistrict || 'ทุกตำบล'

  return (
    <header className="bg-white border-b border-slate-200 px-6 py-5">
      <div className="flex items-center justify-between gap-4">
        {/* Left: Title with icon */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-korat-navy-100 flex items-center justify-center shrink-0">
            <Icon className="w-5 h-5 text-korat-navy-700" aria-hidden />
          </div>
          <div>
            <h1 className="text-lg font-bold text-korat-navy-700">{title}</h1>
            <div className="flex items-center gap-2 mt-0.5">
              <Badge>{districtLabel}</Badge>
              <span className="text-slate-300">·</span>
              <Badge>{subdistrictLabel}</Badge>
            </div>
          </div>
        </div>

        {/* Right: Filters */}
        {showFilters && filters && (
          <div className="flex items-center gap-3">{filters}</div>
        )}
      </div>
    </header>
  )
}
